export const messages = {
  en: {
    accountBond: {
      queryCondition: 'Query Condition',
      inputBondName: 'Please input bond name',
      selectShopType: 'Please select shop type',
      query: 'Query',
      bondInfo: 'Bond Information',
      add: 'Add',
      bondId: 'Bond ID',
      bondName: 'Bond Name',
      amount: 'Amount',
      bondMonth: 'Valid Month',
      bondType: 'Bond Type',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      addBond: 'Add Bond',
      shopType: 'Shop Type',
      selectShopTypeRequired: 'Please select shop type (required)',
      bondNameRequired: 'Bond name is required',
      bondNameLength: 'Bond name length should be 1-20 characters',
      amountRequired: 'Amount is required',
      amountFormat: 'Amount format is incorrect',
      inputAmount: 'Please input amount (required, unit: yuan)',
      inputBondMonth: 'Please input valid month (optional, e.g. 12, 24)',
      inputRemark: 'Please input remark (optional)',
      cancel: 'Cancel',
      save: 'Save',
      editBond: 'Edit Bond',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteBond: 'Confirm to delete this bond?',
      confirmDelete: 'Confirm Delete',
      addSuccess: 'Add bond successfully',
      editSuccess: 'Edit bond successfully',
      deleteSuccess: 'Delete bond successfully',
      bondIdRequired: 'Bond ID is required'
    }
  },
  zh: {
    accountBond: {
      queryCondition: '查询条件',
      inputBondName: '请输入保证金名称',
      selectShopType: '请选择店铺类型',
      query: '查询',
      bondInfo: '保证金信息',
      add: '添加',
      bondId: '保证金ID',
      bondName: '保证金名称',
      amount: '保证金金额',
      bondMonth: '有效月份',
      bondType: '保证金类型',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      addBond: '添加保证金',
      shopType: '店铺类型',
      selectShopTypeRequired: '请选择店铺类型(必填)',
      bondNameRequired: '保证金名称不能为空',
      bondNameLength: '保证金名称长度应为1-20个字符',
      amountRequired: '保证金金额不能为空',
      amountFormat: '保证金金额格式有误',
      inputAmount: '请输入保证金金额(必填，单位：元)',
      inputBondMonth: '请输入有效月份(选填，如12,24)',
      inputRemark: '请输入备注(选填)',
      cancel: '取消',
      save: '保存',
      editBond: '修改保证金',
      confirmOperation: '请确认您的操作',
      confirmDeleteBond: '确定删除该保证金?',
      confirmDelete: '确认删除',
      addSuccess: '添加保证金成功',
      editSuccess: '修改保证金成功',
      deleteSuccess: '删除保证金成功',
      bondIdRequired: '保证金ID不能为空'
    }
  }
}